import type { InjectionKey } from "vue";

// provide(bottomSheetTeleportKey, false) dans une modale Reka (UModal) : toutes les
// AppBottomSheet descendantes se rendent in place au lieu de teleporter vers body
// (cf. commentaire dans AppBottomSheet.vue).
export const bottomSheetTeleportKey: InjectionKey<boolean> = Symbol("bottomSheetTeleport");
